module.exports = __webpack_public_path__ + "img/red-arrow-down.781276a2.svg";